/**
 * @desc 标签
 */

import { RequestConfig, request } from 'umi';

function req(
  data: defs.store.TagRpcDTO,
  config: Parameters<typeof request>[1] = {},
) {
  return request<defs.store.GeneralHttpResponse<number>>(
    `/storeapi/inner/op/tag`,
    {
      data,
      method: 'post',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<number>;
export default req;
